export const CardsConfig = [
  {
    ctype: 'AMEX',
    l1: 4,
    l2: 4,
    l3: 4,
    l4: 3,
    lv: 4,
    desc: 'AMERICAN EXPRESS',
    divine: ['3', '37']
  },
  {
    ctype: 'DC',
    l1: 4,
    l2: 4,
    l3: 4,
    l4: 2,
    lv: 3,
    desc: 'DINERS CLUB',
    divine: []
  },
  {
    ctype: 'DSCV',
    l1: 4,
    l2: 4,
    l3: 4,
    l4: 4,
    lv: 4,
    desc: 'DISCOVER',
    divine: ['6', '60']
  },
  {
    ctype: 'MC',
    l1: 4,
    l2: 4,
    l3: 4,
    l4: 4,
    lv: 3,
    desc: 'MASTER CARD',
    divine: ['5', '54', '52', '53', '55', '51']
  },
  {
    ctype: 'VISA',
    l1: 4,
    l2: 4,
    l3: 4,
    l4: 4,
    lv: 3,
    desc: 'VISA',
    divine: ['4', '40', '45', '47']
  }
];
